import { useEffect } from 'react';
import { useSearchParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { Title } from '../../components/typography/Heading';
import { trackEvent } from '../../support-and-tracking/analytics-actions';
import ModalStickyBottom from '../../components/modal-sticky-bottom/ModalStickyBottom';
import { closeProjectUpdatesModal, openProjectUpdatesModal } from '../project-updates-actions';
import ProjectUpdateList from './ProjectUpdateList';
import I18nText from '../i18n/I18nText';
import { ALL_UPDATES_TEXT_KEY } from '../i18n/project-i18n-model';
import { ProjectSupportButtonsIfActive } from '../project-show/project-support-buttons/project-support-buttons-active/ProjectSupportButtonsIfActive';
import styles from './project-updates-modal.module.less';

export const PROJECT_UPDATES_QUERY_NAME = 'updates';

const ProjectUpdatesModal = () => {
    const dispatch = useDispatch();
    const projectUpdatesModalOpen = useSelector((state) => state.projectUpdates.projectUpdatesModalOpen);
    const [searchParams, setSearchParams] = useSearchParams();
    const showActivity = searchParams.get(PROJECT_UPDATES_QUERY_NAME) === 'true';

    const closeModal = () => {
        dispatch(closeProjectUpdatesModal());
        trackEvent('project-activity-modal', 'close');
    };

    useEffect(() => {
        if (showActivity) {
            dispatch(openProjectUpdatesModal());
            setSearchParams(
                (searchParams) => {
                    searchParams.delete(PROJECT_UPDATES_QUERY_NAME);
                    return searchParams;
                },
                { replace: true }
            );
        }
    }, [showActivity]);

    return (
        <ModalStickyBottom
            isOpen={projectUpdatesModalOpen}
            onRequestClose={closeModal}
            className={styles.modal}
            showCloseButton
        >
            <div className={styles.modalWrapper}>
                <Title tag={'h2'} className={styles.title}>
                    <I18nText textKey={ALL_UPDATES_TEXT_KEY} />
                </Title>
                <div className={styles.modalContent}>
                    <ProjectUpdateList className={styles.projectUpdatesWrapper} />
                </div>

                <ProjectSupportButtonsIfActive className={styles.modalButtons} />
            </div>
        </ModalStickyBottom>
    );
};
export default ProjectUpdatesModal;
